import React, {useCallback, useEffect, useState} from 'react';
import {
	Slider,
	Select,
	Button,
	SelectOption, Loader, Toast,
} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import {isEmpty} from "lodash";
import Styles from "./modal.module.scss";

export type MapStateToPropsType = {
	params: any;
	bridgeNumbers:any,
	bridgeNumberInProgress:boolean|undefined
};

export type MapDispatchToPropsType = {
	onClose: () => void;
	getBridgeNumbers: (params:any) => void;
	editCredential : ( reqData:any,filters:any,keyForIdentifier:string,dynamicUrlData:string, cb?:(res: any, success: boolean)=> void ) => void;
};

const EditCredentialModal: React.FC<MapStateToPropsType & MapDispatchToPropsType> = (
	{
		params,
		onClose,
		editCredential,
		getBridgeNumbers,
		bridgeNumbers,
		bridgeNumberInProgress
	}) => {
	const [cli, setCli] = useState<string>("");
	const { t } = useTranslation();

	useEffect(()=>{
		getBridgeNumbers({voice_sip:1});
		const { selectedCredential } = params;
		if(!isEmpty(selectedCredential)){
			setCli(selectedCredential.cli);
		}
	},[])
	const handleSave = useCallback(() => {
		if(!cli) return;
		editCredential({
			...params.selectedCredential,
			cli
			},{
				credential_group_id:params.credentialGroupId,
				cli:cli
			}, "credential_id",
			params.selectedCredential.credential_id,
			(res:any,success:boolean)=>{
				if(success) Toast(t('KLR00491'),'success');
				else if(res?.data?.message) Toast(res?.data?.message,'error');
			});
		onClose();
	},[cli]);

	const renderFooter = () => {
		return (
			<div className={Styles.footer}>
				<span className={Styles.cancelBtn}>
					<Button type="tertiary" onClick={onClose}>
						{t('mainCancel')}
					</Button>
				</span>
				<Button
					disabled={!cli}
					type="primary"
					onClick={handleSave}
				>
					{t('mainSave')}
				</Button>
			</div>
		);
	};

	return (
		<Slider
			title={t('mainEdit')}
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			footer={renderFooter()}
		>
			{ (bridgeNumberInProgress === undefined || bridgeNumberInProgress) && <Loader/>}
			{ bridgeNumberInProgress === false && <div className={cn(Styles.container)}>
				<div>
					<Select
						label={t('KLR00448')}
						placeholder={t('KLR00448')}
						value={cli}
						onChange={(e) => {
							setCli((e||"").toString());
						}}
					>
						<SelectOption
							key={'default'}
							value={"Default"}
							className={Styles.defaultSelect}
						>
							{t("KLR00449")}
						</SelectOption>
						{!isEmpty(bridgeNumbers?.bridge_numbers) && Object.keys(bridgeNumbers.bridge_numbers).map( (key:any) => {
							return (
								<SelectOption
									key={key}
									value={key}
								>
									{bridgeNumbers.bridge_numbers[key]}
								</SelectOption>
							);
						})}
					</Select>
				</div>
			</div>}
		</Slider>
	);
};

export default EditCredentialModal;
